import { render, staticRenderFns } from "./comCheck.vue?vue&type=template&id=34bd246c&scoped=true&"
import script from "./comCheck.vue?vue&type=script&lang=js&"
export * from "./comCheck.vue?vue&type=script&lang=js&"
import style0 from "./comCheck.vue?vue&type=style&index=0&id=34bd246c&scoped=true&lang=css&"
import style1 from "./comCheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd246c",
  null
  
)

export default component.exports